import { render, staticRenderFns } from "./ColourMatchModal.vue?vue&type=template&id=56c7efe3&"
import script from "./ColourMatchModal.vue?vue&type=script&lang=js&"
export * from "./ColourMatchModal.vue?vue&type=script&lang=js&"
import style0 from "./ColourMatchModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports